var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "discussion discussion-facebook" },
    [
      _c(
        "div",
        { staticClass: "detail-event-header" },
        [
          _c("AvatarComponent", {
            attrs: {
              typeNetwork: _vm.page.network,
              urlPicture:
                _vm.event.user &&
                _vm.event.user.picture.data &&
                _vm.event.user.picture.data.url
                  ? _vm.event.user.picture.data.url
                  : null,
            },
          }),
          _c("div", { staticClass: "info" }, [
            _c("div", { staticClass: "namePage" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.getRecipientInfo().name) +
                  "\n              "
              ),
            ]),
            _vm._m(0),
          ]),
          _c(
            "div",
            { staticClass: "selectActionEvent" },
            [
              _c("SelectComponent", {
                attrs: {
                  changeValueSelect: _vm.changeStatus,
                  data: {
                    treated: _vm.$t("dash.inbox.state.treated"),
                    waiting: _vm.$t("dash.inbox.state.waiting"),
                  },
                  valueSelect: [1, 3].includes(_vm.event.status)
                    ? "treated"
                    : "waiting",
                  positionY: "bottom",
                  positionAuto: false,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      !_vm.isLoading &&
      Object.keys(_vm.infoConversation).length &&
      Object.keys(_vm.infoUser).length
        ? _c(
            "ul",
            {
              ref: "discussionScrool",
              staticClass: "discussion-order scrollable",
            },
            [
              _vm._l(_vm.messages.data, function (discut, key) {
                return _c("li", { key: key }, [
                  !_vm.messages.data[key + 1] ||
                  new Date(discut.created_time).getTime() -
                    new Date(
                      _vm.messages.data[key + 1].created_time
                    ).getTime() >
                    900000
                    ? _c("div", { staticClass: "date" }, [
                        _vm._v(_vm._s(_vm.dateFormat(discut.created_time))),
                      ])
                    : _vm._e(),
                  discut.from.id != _vm.page.network_id
                    ? _c("div", { staticClass: "message-received" }, [
                        _c("div", { staticClass: "message-received-content" }, [
                          _c(
                            "div",
                            {
                              staticClass: "message-received-content-text",
                              class: {
                                text:
                                  discut.message &&
                                  (discut.message.length ||
                                    (!discut.message.length &&
                                      !discut.attachments)),
                              },
                            },
                            [
                              discut.message.length ||
                              (!discut.message.length && !discut.attachments)
                                ? _c("p", [_vm._v(_vm._s(discut.message))])
                                : _vm._e(),
                              discut.attachments
                                ? _c("img", {
                                    staticClass:
                                      "message-received-content-image",
                                    attrs: {
                                      src: discut.attachments.data[0].image_data
                                        .url,
                                    },
                                  })
                                : _vm._e(),
                              _c(
                                "div",
                                {
                                  staticClass: "containerReactions",
                                  class: { isHide: true },
                                },
                                [_vm._m(1, true)]
                              ),
                            ]
                          ),
                        ]),
                        _c("div", { staticClass: "container-actions-message" }),
                      ])
                    : discut.from.name == _vm.page.name
                    ? _c("div", { staticClass: "message-sent" }, [
                        _c(
                          "div",
                          { staticClass: "message-sent-content" },
                          [
                            _c(
                              "ContextMenu",
                              {
                                attrs: {
                                  options: [
                                    {
                                      label: _vm.$t("dash.button.delete"),
                                      name: "deleteComment",
                                    },
                                  ],
                                  id: discut.id,
                                },
                                on: { clickOption: _vm.clickOptionMessage },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa-solid fa-ellipsis-vertical",
                                }),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "message-sent-content-text",
                                class: {
                                  text: discut.message && discut.message.length,
                                },
                              },
                              [
                                discut.message && discut.message.length
                                  ? _c("p", [_vm._v(_vm._s(discut.message))])
                                  : _vm._e(),
                                discut.attachments &&
                                typeof discut.attachments.data[0].image_data !=
                                  "undefined"
                                  ? _c("img", {
                                      staticClass:
                                        "message-received-content-image",
                                      attrs: {
                                        src: discut.attachments.data[0]
                                          .image_data.url,
                                      },
                                    })
                                  : _vm._e(),
                                _c(
                                  "div",
                                  {
                                    staticClass: "containerReactions",
                                    class: { isHide: true },
                                  },
                                  [_vm._m(2, true)]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "container-actions-message" },
                          [
                            discut.tags.data[2].name == "echec" ||
                            discut.tags.data[1].name == "echec"
                              ? _c("div", { staticClass: "status" }, [
                                  _vm._v("Echec de l'envoi"),
                                ])
                              : _vm.getIndexLastMessageSend == key
                              ? _c("div", { staticClass: "status" }, [
                                  _vm._v("Envoyé"),
                                ])
                              : _vm._e(),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ])
              }),
              _c("li", { staticClass: "loading-other-message" }, [
                _vm.messages.paging.next
                  ? _c("div", { staticClass: "util-loader" })
                  : _vm._e(),
                _vm.messages.paging.next
                  ? _c("p", [_vm._v("Chargement des anciens messages")])
                  : _c("p", [_vm._v("Debut de la conversation")]),
              ]),
            ],
            2
          )
        : _c(
            "ul",
            { staticClass: "discussion-order scrollable" },
            _vm._l(8, function (index) {
              return _c("li", { key: index }, [
                Math.random() > 0.5
                  ? _c(
                      "div",
                      { staticClass: "message-received content-loading" },
                      [
                        _c("div", { staticClass: "message-received-content" }, [
                          _c(
                            "div",
                            {
                              staticClass: "message-received-content-text text",
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  _vm._s("w".repeat(5 + Math.random() * 100))
                                ),
                              ]),
                            ]
                          ),
                        ]),
                        _c("div", { staticClass: "container-actions-message" }),
                      ]
                    )
                  : _c("div", { staticClass: "message-sent content-loading" }, [
                      _c("div", { staticClass: "message-sent-content" }, [
                        _c(
                          "div",
                          { staticClass: "message-sent-content-text text" },
                          [
                            _c("p", [
                              _vm._v(
                                _vm._s("w".repeat(5 + Math.random() * 100))
                              ),
                            ]),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "container-actions-message" }),
                    ]),
              ])
            }),
            0
          ),
      _c("FormSendMessage", {
        attrs: { acceptTypeMedia: "image/*" },
        on: { onSubmitMessage: _vm.onSubmitMessage },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "typeEvent" }, [
      _c("p", [_vm._v("Discussion privée")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "reactions" }, [
      _c("i", [_vm._v("😀")]),
      _c("i", { staticClass: "fa-regular fa-face-smile" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "reactions" }, [
      _c("i", [_vm._v("😀")]),
      _c("i", { staticClass: "fa-regular fa-face-smile" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }